import { Box, ButtonBase, Card, styled } from '@mui/material';

// export const ClickableCardBase = styled(ButtonBase)(({ theme }) => ({
//   display: 'block',
//   width: '100%',
//   minWidth: 0,
//   borderRadius: theme.shape.borderRadius,
//   overflow: 'hidden',
// }));

// export const ClickableCard = styled(Card)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   width: '100%',
//   minWidth: 0,
//   flexShrink: 1,
//   backgroundColor: "transparent",
//   boxShadow: "none",
//   overflow: 'hidden',
//   borderRadius: theme.shape.borderRadius,
//   transition: "background-color 0.3s ease-in-out",
//   '&:hover': {
//     cursor: 'pointer',
//     backgroundColor: 'rgba(0,0,0,0.02)',
//   },
//   '&:active': {
//     backgroundColor: 'rgba(0,0,0,0.08)',
//   },
// }));

// interface ImageContainerProps {
//   playable?: boolean;
//   hoverDisabled?: boolean;
// }

// export const ImageContainer = styled(Box, {
//   shouldForwardProp: (prop) => prop !== 'playable',
// })<ImageContainerProps>(({ theme, playable, hoverDisabled }) => ({
//   position: 'relative',
//   overflow: 'hidden',
//   borderRadius: '12px',
//   marginTop: 12,
//   height: 'auto',
//   transition: 'transform 0.5s cubic-bezier(.4,2,.6,1), box-shadow 0.3s, margin-top 0.3s',
//   ...(playable && {
//     '&:hover': {
//       transform: hoverDisabled ? 'none' : 'translateY(-12px)',
//       // boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
//     },
//   }),
// }));

interface ImageContainerProps {
  playable?: boolean;
  hoverDisabled?: boolean;
}

export const ImageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'playable' && prop !== 'hoverDisabled',
})<ImageContainerProps>(({ playable, hoverDisabled }) => ({
  position: 'relative',
  overflow: 'visible', // so the scaled preview isn’t clipped
  borderRadius: 12,
  marginTop: 12,
  transition: 'transform 0.5s cubic-bezier(.4,2,.6,1), box-shadow 0.3s, margin-top 0.3s',

  ...(playable && {
    '&:hover': {
      transform: hoverDisabled ? 'none' : 'translateY(-12px)',
      cursor: 'pointer',
    },
    '&:hover .hoverPreview': {
      opacity: 1,
      transform: 'scale(1.45)',
    }
  }),
}));

export const ClickableCardBase = styled(ButtonBase)(({ theme }) => ({
  display: 'block',
  width: '100%',
  minWidth: 0,
  borderRadius: theme.shape.borderRadius,
  overflow: 'visible',
}));

export const ClickableCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  overflow: 'visible',
  borderRadius: theme.shape.borderRadius,
  transition: 'background-color 180ms ease',
  zIndex: 0,

  '&:hover': {
    backgroundColor: 'rgba(0,0,0,0.02)',
    zIndex: 20,
  },

  '&:hover .hoverPreview': {
    opacity: 1,
    transformOrigin: 'left top',
    transform: 'scale(1.45)',
  }
}));


export const ImageOuter = styled(Box)(() => ({
  position: 'relative',
  overflow: 'visible',
  width: '100%',
}));

export const ImageClipper = styled(Box)(() => ({
  borderRadius: 12,
  overflow: 'hidden',
  width: '100%',
  height: 'auto',
  position: 'relative',
  '& img': {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 300ms ease',
  },
}));

interface HoverPreviewProps {
  align?: 'left' | 'center';
}

export const HoverPreview = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'align',
})<HoverPreviewProps>(({ align = 'left' }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: 12,
  overflow: 'hidden',
  boxShadow: '0 12px 40px rgba(0,0,0,0.36)',
  transformOrigin: align === 'center' ? 'center center' : 'left top',
  transform: 'scale(1)',
  opacity: 0,
  zIndex: 3000,
  pointerEvents: 'none',
  transition: 'transform 300ms cubic-bezier(.2,.8,.2,1), opacity 300ms ease',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    borderRadius: 12,
    transition: 'transform 300ms cubic-bezier(.2,.8,.2,1)',
  },
}));